/* 🤖 this file was generated by svg-to-ts */
export const iconPlus: {
    name: 'plus';
    data: string;
} = {
    name: 'plus',
    data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 341.4 341.4"><path d="M192 149.4V0h-42.6v149.4H0V192h149.4v149.4H192V192h149.4v-42.6z"/></svg>`
};
